import React, { Component } from 'react'
// import PlanScreen from './PlanScreen.jsx'
import { connect } from 'react-redux'
import { bindActionCreators, compose } from 'redux'
import { withRouter } from 'react-router'
import * as userActions from '../../actions/userActions'
import {
  editUserTrainingDays,
  getTrainingDays,
  getUserData,
  setUserTrainingDays,
} from '../../Api/backendApi'
import cookie from 'react-cookies'
import { trackPromise } from 'react-promise-tracker'

import { getAllUserWatchedVideos } from '../../Api/videoApi'

import PlanScreen from './Red_PlanScreen.tsx'

class PlanScreenContainer extends Component {
  state = {
    // openMenu: false,
    // isPlayerActive: false,
    // trainingDays: [],
    // trainingDaysId: null,
    // isLoading: false,
    // redmindAboutTraining: false,
    // trainingHour: null,
    // trainingMinute: null,
    // tempTrainingTime: null,
    // isPlanChanged: false,
    // isEditModalOpen: false,
    // isUserLoggedIn: cookie.load('accessToken') ? true : false,
    // isSetModalOpen: false,
    // isDemoAccount: cookie.load('userDemoMode'),
  }

  // componentDidMount = async () => {
  //   if (!this.state.user) {
  //     await this.obtainUserData()
  //   }

  //   if (!this.state.isUserLoggedIn || this.state.user.name == '') {
  //     this.props.history.push('/')
  //     return
  //   }

  //   await this.obtainUserTrainingData()
  // }

  // obtainUserData = async () => {
  //   const user = await trackPromise(getUserData())

  //   this.setState({
  //     user: user,
  //   })
  // }

  // obtainUserTrainingData = async () => {
  //   if (this.state.trainingDays.length == 0) {
  //     const userTraining = await trackPromise(getTrainingDays())
  //     this.setState({
  //       trainingDays: userTraining ? userTraining.trainingDays : null,
  //       trainingDaysId: userTraining ? userTraining.trainingId : null,
  //       redmindAboutTraining: userTraining
  //         ? userTraining.notification_enabled
  //         : null,
  //       trainingHour: userTraining ? userTraining.hour : null,
  //       trainingMinute: userTraining ? userTraining.minute : null,
  //     })
  //   }
  // }

  // onOpenMenuClick = () => {
  //   this.setState({
  //     openMenu: !this.state.openMenu,
  //   })
  // }

  // closeMenu = () => {
  //   this.setState({
  //     openMenu: false,
  //   })
  // }

  // changeLocation = (location) => {
  //   this.props.history.push(location)
  // }

  // onSubpageChange = (page) => {
  //   this.setState({
  //     actualPage: page,
  //   })
  // }
  // setLoader = () => {
  //   this.setState({
  //     isLoading: !this.state.isLoading,
  //   })
  // }

  // cancelEditTrainingDays = async () => {
  //   this.setState({
  //     isPlanChanged: false,
  //     isEditModalOpen: false,
  //   })
  //   this.setLoader()
  //   const userTraining = await getTrainingDays()

  //   this.setState({
  //     trainingDays: userTraining.trainingDays,
  //     trainingDaysId: userTraining.trainingId,
  //   })
  //   this.setLoader()
  // }

  // setTraining = () => {
  //   const time = this.state.tempTrainingTime

  //   let hour
  //   let minutes

  //   if (this.state.tempTrainingTime !== null) {
  //     hour = time.split(':')[0]
  //     minutes = time.split(':')[1]
  //   } else {
  //     hour = 12
  //     minutes = 0
  //   }
  //   setUserTrainingDays(this.state.trainingDays, hour, minutes)
  // }
  // storeTraining = async () => {
  //   const time = this.state.tempTrainingTime
  //   let splitted
  //   if (this.state.tempTrainingTime !== null) {
  //     splitted = time.split(':')
  //   } else {
  //     splitted = [this.state.trainingHour, this.state.trainingMinute]
  //   }

  //   this.setLoader()

  //   editUserTrainingDays(
  //     this.state.trainingDays,
  //     this.state.trainingDaysId,
  //     splitted,
  //     this.state.redmindAboutTraining
  //   )

  //   this.setState({
  //     isPlanChanged: false,
  //     isEditModalOpen: false,
  //   })

  //   this.setLoader()
  // }
  // checkTrenningDay = (e, day) => {
  //   this.setState({
  //     isPlanChanged: true,
  //   })
  //   let filtered
  //   if (this.state.trainingDays) {
  //     if (!this.state.trainingDays.includes(day)) {
  //       this.setState({
  //         trainingDays: [...this.state.trainingDays, day],
  //       })
  //     } else {
  //       filtered = this.state.trainingDays.filter((days) => days !== day)
  //       this.setState({
  //         trainingDays: [...filtered],
  //       })
  //     }
  //   } else {
  //     this.setState({
  //       trainingDays: [day],
  //     })
  //   }
  // }

  // checkTrainingReminder = () => {
  //   this.setState({
  //     isPlanChanged: true,
  //   })
  //   this.setState({
  //     redmindAboutTraining: !this.state.redmindAboutTraining,
  //   })
  // }
  // changeRemindTrainingTime = (e) => {
  //   this.setState({
  //     isPlanChanged: true,
  //   })
  //   this.setState({
  //     tempTrainingTime: e.target.value,
  //   })
  // }

  // openEditModal = () => {
  //   this.setState({
  //     isEditModalOpen: true,
  //   })
  // }

  // closeEditModal = () => {
  //   this.setState({
  //     isEditModalOpen: false,
  //   })
  //   this.cancelEditTrainingDays()
  // }

  // openSetModal = () => {
  //   this.setState({
  //     isSetModalOpen: true,
  //   })
  // }

  // closeSetModal = () => {
  //   this.setState({
  //     isSetModalOpen: false,
  //   })
  // }

  render() {
    return (
      // <PlanScreen
      //   onSubpageChange={this.onSubpageChange}
      //   changeLocation={this.changeLocation}
      //   closeMenu={this.closeMenu}
      //   onOpenMenuClick={this.onOpenMenuClick}
      //   openMenu={this.state.openMenu}
      //   isPlayerActive={this.state.isPlayerActive}
      //   user={this.state.user}
      //   editTrainingDays={this.editTrainingDays}
      //   checkTrenningDay={this.checkTrenningDay}
      //   trainingDays={this.state.trainingDays}
      //   nbCheckedCheckboxes={
      //     this.state.trainingDays ? this.state.trainingDays.length : 0
      //   }
      //   storeTraining={this.storeTraining}
      //   cancelEditTrainingDays={this.cancelEditTrainingDays}
      //   chartData={this.state.chartData}
      //   isLoading={this.state.isLoading}
      //   checkTrainingReminder={this.checkTrainingReminder}
      //   redmindAboutTraining={this.state.redmindAboutTraining}
      //   changeRemindTrainingTime={this.changeRemindTrainingTime}
      //   trainingHour={this.state.trainingHour}
      //   trainingMinute={this.state.trainingMinute}
      //   tempTrainingTime={this.state.tempTrainingTime}
      //   isPlanChanged={this.state.isPlanChanged}
      //   isEditModalOpen={this.state.isEditModalOpen}
      //   closeEditModal={this.closeEditModal}
      //   openEditModal={this.openEditModal}
      //   trainingDays={this.state.trainingDays}
      //   setTraining={this.setTraining}
      //   isSetModalOpen={this.state.isSetModalOpen}
      //   openSetModal={this.openSetModal}
      //   closeSetModal={this.closeSetModal}
      //   isDemoAccount={this.state.isDemoAccount}
      // />
      <PlanScreen />
    )
  }
}

// function mapDispatchToProps(dispatch) {
//   return {
//     userActions: bindActionCreators(userActions, dispatch),
//   }
// }

// function mapStateToProps(state) {
//   return {
//     user: state.user,
//   }
// }

// export default compose(
//   withRouter,
//   connect(mapStateToProps, mapDispatchToProps)
// )(PlanScreenContainer)

export default PlanScreenContainer
